import * as striptags from 'striptags';
import { decodeHtmlEntities } from '../../common/helpers/htmlEntities';
import { TitleAboutProps } from '../title-about/TitleAbout.props';
import { joinUrl, toAbsoluteUrl } from './urlUtils';

export interface BuildMovieJsonLdInput {
  titleAboutProps: TitleAboutProps;
  siteRoot: string;
  currentPath: string;
}

// Strip HTML tags BEFORE decoding entities so attribute values like `<a title="&gt;">` don't get
// turned into stray `>` characters. `striptags` is environment-independent (works in both browser
// and the static-site-generation Node runtime), unlike DOMParser which is browser-only.
const stripHtml = (html: string): string =>
  decodeHtmlEntities(striptags(html))
    .replace(/\s+/g, ' ')
    .trim();

export const buildMovieJsonLd = ({
  titleAboutProps,
  siteRoot,
  currentPath,
}: BuildMovieJsonLdInput): Record<string, unknown> => {
  const { title, about, keyart, genres, releaseDate, seo } = titleAboutProps;

  const rawDescription = seo?.description || about || '';
  const description = rawDescription ? stripHtml(rawDescription) : undefined;

  const image = toAbsoluteUrl(siteRoot, keyart?.src);
  const datePublished = releaseDate?.show && releaseDate.date ? releaseDate.date : undefined;
  const genre = genres && genres.length > 0 ? genres : undefined;

  const data: Record<string, unknown> = {
    '@context': 'https://schema.org',
    '@type': 'Movie',
    name: decodeHtmlEntities(title),
    url: joinUrl(siteRoot, currentPath),
  };

  if (description) data.description = description;
  if (image) data.image = image;
  if (genre) data.genre = genre;
  if (datePublished) data.datePublished = datePublished;

  return data;
};
